import { Slider } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

// The player is remounted for every asset. The buffered bar starts from the
// previous video's value, so the rail does not blink empty and full again
let lastBufferedPercent: { value: number; hiddenAt: number } | null = null;
// Only when navigating, not when the viewer is opened again later
const LAST_BUFFERED_MAX_AGE_MS = 1000;
// Kept at most this long while the new video has not buffered anything
const LAST_BUFFERED_MAX_SHOWN_MS = 300;

function takeLastBufferedPercent() {
  const last = lastBufferedPercent;
  lastBufferedPercent = null;
  if (!last || Date.now() - last.hiddenAt > LAST_BUFFERED_MAX_AGE_MS) {
    return null;
  }
  return last.value;
}

function LoadedBar({
  buffered,
  duration
}: {
  buffered: number;
  duration: number;
}) {
  const percent = duration ? Math.min((buffered / duration) * 100, 100) : 0;

  const [previousPercent, setPreviousPercent] = useState(
    takeLastBufferedPercent
  );
  useEffect(() => {
    if (previousPercent === null) return;
    if (percent > 0) {
      setPreviousPercent(null);
      return;
    }
    const timeout = setTimeout(
      () => setPreviousPercent(null),
      LAST_BUFFERED_MAX_SHOWN_MS
    );
    return () => clearTimeout(timeout);
  }, [previousPercent, percent]);

  const percentRef = useRef(percent);
  percentRef.current = percent;
  useEffect(
    () => () => {
      lastBufferedPercent = {
        value: percentRef.current,
        hiddenAt: Date.now()
      };
    },
    []
  );

  return (
    <Slider className="loaded" value={previousPercent ?? percent} step={0.1} />
  );
}

export default LoadedBar;
